import { render, staticRenderFns } from "./linkedinLogin.vue?vue&type=template&id=15843ad4&scoped=true"
import script from "./linkedinLogin.vue?vue&type=script&lang=js"
export * from "./linkedinLogin.vue?vue&type=script&lang=js"
import style0 from "./linkedinLogin.vue?vue&type=style&index=0&id=15843ad4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15843ad4",
  null
  
)

export default component.exports